var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.invoice)?_c('v-text-field',{staticClass:"mt-5",attrs:{"filled":"","dense":"","label":"Invoice","value":_vm.invoice.reference}}):_c('v-btn',{attrs:{"color":"primary","loading":_vm.isSaving,"disabled":_vm.disabled,"title":_vm.title},on:{"click":_vm.createInvoice}},[_vm._v(" "+_vm._s(_vm.$$t(_vm.buttonText))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }